export * from './status-painel-de-atendimento.pipe';
